
import { CargoController } from "@/app/ui/controllers/CargoController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import {
  ReadyToCargo,
  ReadyToCargoListEntities,
  RequestCheckEligibleReadyToCargo,
  RequestReadyToCargoList
} from "@/domain/entities/ReadyToCargo";
import { Options, mixins } from "vue-class-component";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import CardReadyToCargo from "@/app/ui/views/cargo/booking-cargo/components/card-ready-to-cargo.vue";
import { GTMBookingCargoEvent } from "@/app/infrastructures/misc/gtm-event/custom-events/booking-cargo-event";
import { ModalMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import { NGenController } from "@/app/ui/controllers/NGenController";
import { getTokenNGen } from "@/app/infrastructures/misc/Cookies";
import ModalCargoType from "@/app/ui/views/cargo/booking-cargo/components/modal-cargo-type.vue";
import {
  checkRolePermission,
  firstCapitalize,
  storeDatatoSessionStorage,
  commaDecimalToDecimal,
  dateTimePayload,
  formatDate,
  convertDecimalAfterComma,
  parsingErrorResponse,
  parseByCountry
} from "@/app/infrastructures/misc/Utils";
import {
  CargoInputData,
  CargoDetailStt,
  DimensionData
} from "@/domain/entities/Cargo";
import { CALCULATE_TYPE, cargoTypeData, getConfigDimensionDivider, handleFailedBookingNavigation, SESSION_STORAGE_CARGO_KEY, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece } from "../../modules/cargo-module";
import { CargoPlaneAutoData } from "@/domain/entities/Cargo";
import { AddBagOrStt, CalculateVolumeApiRequest, CalculateVolumeRequest, DimensionPieces } from "@/data/payload/api/CargoApiRequest";
import { gtmCargoData } from "../../modules/gtm";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { capitalize } from "@vue/shared";
import { flags } from "@/feature-flags";
import Print from "@/app/ui/views/cargo/modules/print.vue";
import OutGoingMixins from "@/app/ui/views/out-going-shipment/out-going-mixin";
import { defineAsyncComponent } from "@vue/runtime-core";
import { ClientController } from "@/app/ui/controllers/ClientController";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import ConfigFeatureFlight from "@/app/ui/views/cargo/booking-cargo/config-feature-flight/config-feature-flight.vue";
const Gamification = defineAsyncComponent(() =>
  import(
    "@/app/ui/views/cargo/booking-cargo/components/gamification-rtc-modal/index.vue"
  )
);
import { getDataSessionStorage } from "@/app/infrastructures/misc/Utils";
/* eslint-disable @typescript-eslint/camelcase */

@Options({
  components: {
    PaginationV3,
    CardReadyToCargo,
    ModalCargoType,
    Print,
    Gamification,
    ConfigFeatureFlight
  }
})
export default class ReadyToCargoFlow extends mixins(OutGoingMixins) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  beforeMount() {
    this.setFlowBooking("");
  }

  async mounted() {
    this.getTabs();
    this.onReset();
    this.showSelectAirport = false;
    this.setDefaultDataToAirportPopup();
    this.formBooking.isChangeAirport = false;
    this.showSelectAirportToLocalStorage = false;
    ReadyToCargoController.setEventName("");
    CargoController.resetErrorDiffPiecesActualThanDimensionPieces();
    CargoController.setIsChangeVolumeActual(false);
    await this.getListRTCByCargoType();
    if (!this.readyToCargoList.data.length) {
      if (this.flagsGamification) {
        CargoController.setIsModalGamification(true);
        CargoController.setIsModalGamificationDone(false);
      }
      ReadyToCargoController.setFlowBooking("manual");
      CargoController.setProgressValue(0);
      ReadyToCargoController.setEventName("booking_cargo");
    }

    this.getCargoProductList();
  }

  get errorContainer() {
    const { clientValue, destinationCityRTC } = this;
    let errorDetails = {
      errorIcon: "data-not-found",
      errorTitle: "Data tidak ditemukan",
      errorMessage: "Maaf, data yang Anda cari tidak ditemukan."
    };

    if (clientValue && !destinationCityRTC) {
      errorDetails = {
        errorIcon: "noData_filter",
        errorTitle:
          "Belum ada daftar siap dikargo yang sesuai filter klien ini.",
        errorMessage: "Cek kembali atau ubah filter Anda."
      };
    }

    return errorDetails;
  }

  get clientValue() {
    return CargoController.clientValue;
  }

  get readyToCargoList() {
    return CargoController.readyToCargoList;
  }

  get destinationCityRTC() {
    return CargoController.destinationCityRTC;
  }

  get flowBooking() {
    return ReadyToCargoController.flowBooking;
  }

  async onProcessSelectSchedule(callback: () => void) {
    const isEligible = await this.checkEligible();
    if (!isEligible) return;

    callback();
  }
  closePopUpPlane() {
    this.fetchAirportOrigin(this.originCity.code || "");
    this.onReset();
  }

  onReset() {
    this.setFlowBooking("");
    storeDatatoSessionStorage("cargo", []);
    storeDatatoSessionStorage("cargo-bag", []);
    storeDatatoSessionStorage("event-name", "");
    storeDatatoSessionStorage("rtc-flights-data", []);
    storeDatatoSessionStorage("next-rtc-flights-data", []);
    storeDatatoSessionStorage("calculate-flight-date", []);
    storeDatatoSessionStorage("show-select-airport", false);
    storeDatatoSessionStorage("cargo-type", {});
    storeDatatoSessionStorage("fill-form", false);
    storeDatatoSessionStorage("error-awb", "");
    storeDatatoSessionStorage("isEditReadyToCargo", false);
    storeDatatoSessionStorage("error-awb", "");
    storeDatatoSessionStorage("setShowPlaneSchedule", false);
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY,
      false
    );
    CargoController.setSTTResultFinal([]);
    CargoController.setBagResult([]);
    CargoController.setSourceFromLocalStorage([]);
    ReadyToCargoController.setCalculateFlightDate([]);
    ReadyToCargoController.setDetailFlightData([]);
    ReadyToCargoController.setDetailNextFlightData([]);
    CargoController.setNotificationWeight(false);
    CargoController.setResetDestinationCity();
    CargoController.resetTotalActualGrossWeight();
    CargoController.resetCargoInputForm(new CargoInputData());
    CargoController.setShowModalCargoType(false);
    NGenController.setErrorAwb("");
    CargoController.setShowSelectAirportToLocalStorage(false);
    CargoController.resetIsEditReadyToCargo();
    ReadyToCargoController.setReadyToCargoDetail(new ReadyToCargo());
    CargoController.resetForm();
    CargoController.setIsChangeCargoType(false);
    this.readyToCargoList.pagination.page = 1;
    CargoController.resetCargoData();
  }

  setAirportPopUpModel(val: any) {
    CargoController.setAirportsPopupModel(val);
  }

  setDefaultDataToAirportPopup() {
    this.setAirportPopUpModel(
      JSON.parse(JSON.stringify(this.formBooking.airports))
    );
  }

  set showSelectAirportToLocalStorage(bool: boolean) {
    CargoController.setShowSelectAirportToLocalStorage(bool);
  }

  get showModalCargoPlaneAuto() {
    return CargoController.showSelectAirport;
  }

  get showSelectAirport() {
    return CargoController.showSelectAirport;
  }
  set showSelectAirport(bool: boolean) {
    CargoController.setShowSelectAirport(bool);
  }

  get showModalCargoType() {
    return CargoController.showModalCargoType;
  }

  get isEditReadyToCargo() {
    return CargoController.isEditReadyToCargo;
  }

  get originCity(): OptionsClass {
    const detailDistrict = LocationController.districtDetail;
    return new OptionsClass({
      name: `${detailDistrict.cityCode} - ${firstCapitalize(
        detailDistrict.cityName.toLowerCase()
      )}`,
      code: detailDistrict.cityCode
    });
  }

  get formBooking() {
    return CargoController.form;
  }

  // transport type
  transportType = new OptionsClass();
  transportTypeData = [
    new OptionsClass({
      name: "plane",
      value: "plane"
    }),
    new OptionsClass({
      name: "truck",
      value: "truck"
    }),
    new OptionsClass({
      name: "train",
      value: "train"
    }),
    new OptionsClass({
      name: "ship",
      value: "ship"
    })
  ];

  async getListRTCByCargoType() {
    const tab = !this.tabs.length ? this.transportTypeData : this.tabs;
    for (const item of tab) {
      CargoController.setActiveTabs(item.name);
      await this.fetchReadyToCargoList();
      if (this.readyToCargoList.data.length) {
        CargoController.setActiveTabs(item.name);
        break;
      }
    }
  }

  get isLoading() {
    return MainAppController.loadingModal;
  }

  async fetchReadyToCargoList() {
    MainAppController.showLoading();
    CargoController.setReadyToCargoList(
      await ReadyToCargoController.getReadyToCargoList(
        new RequestReadyToCargoList({
          page: this.readyToCargoList.pagination.page,
          limit: this.readyToCargoList.pagination.limit,
          destinationCode: this.destinationCityRTC.code,
          transportType: this.activeTabs
        })
      )
    );
    MainAppController.closeLoading();
  }
  async initPlaneAuto(data: any): Promise<void> {
    await this.fetchAirportOrigin(this.originCity.code || "");
    await this.fetchAirportDestination(data.destinationCode);
  }

  fetchAirportOrigin(search: string) {
    search = search || "";
    search = search.split(" - ").length > 1 ? search.split(" - ")[1] : search;
    return CargoController.getAirportListOrigin({
      airportCode: "",
      cityCode: search,
      page: 1,
      limit: 10,
      isLocation: false
    });
  }
  fetchAirportDestination(search: string) {
    search = search || "";
    search = search.split(" - ").length > 1 ? search.split(" - ")[1] : search;
    return CargoController.getAirportListDestination({
      airportCode: "",
      cityCode: search,
      page: 1,
      limit: 10
    });
  }

  get cargoInputForm() {
    return CargoController.cargoInputForm;
  }

  showModalForm = false;
  dataReadyToCargo: ReadyToCargo = new ReadyToCargo();
  async setShowModalForm(
    data: ReadyToCargo,
    withPrint: boolean,
    label: boolean,
    bookingAutoType: "rtc" | "genesis"
  ) {
    if (data.cargoType !== "plane") {
      this.withPrint = withPrint;
      this.withPrintLabel = label;
    }
    this.dataReadyToCargo = data;

    if (data.isMoreThanCutOffTime && bookingAutoType === "genesis") {
      this.showModalForm = false;
      await this.onProcessReadyToCargo(data, bookingAutoType, false);
      const isEligible = await this.checkEligible();
      if (!isEligible) {
        CargoController.setShowSelectAirportToLocalStorage(false);
        this.showSelectAirport = false
        CargoController.setCargoInputForm(new CargoInputData()); //reset rtc data;
        await this.$nextTick();
        return
      }
      return;
    }
    try {
      await ReadyToCargoController.getDetailReadyToCargo(data.id, "rtc-process");
      if (!ReadyToCargoController.readyToCargoDetail.detail.length) {
        ReadyToCargoController.readyToCargoDetail.detail = [
          new CargoDetailStt({
            sttNumber: "-"
          })
        ]
        await this.$nextTick();
      }
    } catch (error) {
      this.fetchReadyToCargoList();
      return;
    }
    this.onMappingCommodityGroup();
    const isEligible = await this.checkEligible();
    if (!isEligible) return;
    this.showModalForm = true;
    this.handleProductInactive();
    
  }

  handleProductInactive() {
    const productFound = CargoController.cargoProductList.data.find(product => product.cargoProductTypeCode === this.formBooking.cargoProduct);

    if (!productFound) this.formBooking.cargoProduct = CargoController.cargoProductList.data[0].cargoProductTypeCode;
  }

  async onMappingCommodityGroup() {
    await CargoController.mappingReadyToCargo();
    await CargoController.mappingCommodityOptions();
  }

  checkNeedRefreshData(data: ReadyToCargo): boolean {
    // validate if data need refresh
    const { isMoreThanCutOffTime, cutOffTime } = data;
    if (!isMoreThanCutOffTime) {
      const [hours, minutes, seconds] = cutOffTime?.split(":").map(Number);
      const rtcDate = new Date(
        new Date().setHours(hours, minutes, seconds)
      ).getTime();
      const now = new Date().getTime();
      if (rtcDate < now) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "sync-paket",
            title: "Ada pembaharuan data, silakan cek kembali",
            textSuccess: "Oke",
            onSubmit: async () => {
              CargoController.setReadyToCargoList(
                new ReadyToCargoListEntities()
              );
              this.getListRTCByCargoType();
              MainAppController.closeMessageModal();
            }
          })
        );
        return false;
      }
    }
    return true;
  }

  async checkEligible() {
    const payloadBagNoOnly = JSON.parse(
      getDataSessionStorage("cargo-bag") || "[]"
    )
      .map((item: any) => new AddBagOrStt(item.baggingNumber))
      .filter((items: any) => items != null);

    const payloadSttNoOnly = JSON.parse(getDataSessionStorage("cargo") || "[]")
      .filter(
        (item: any) =>
          !JSON.parse(
            getDataSessionStorage("cargo-bag") || "[]"
          ).find((bag: any) => JSON.stringify(bag).includes(item.sttNumber)) ||
          JSON.parse(getDataSessionStorage("cargo-bag") || "[]").find(
            (itemBag: any) => item.isFromRebooking == itemBag.isFromRebooking // add validation to check on cargo-bag that come from rebooking
          )
      )
      .map((item: any) => {
        if (item.sttDetails) {
          return item.sttDetails.map(
            (item: any) => new AddBagOrStt(undefined, item.sttNumber)
          );
        } else {
          return new AddBagOrStt(undefined, item.sttNumber);
        }
      })
      .flat();
      
    const bagOrSttForCheckEligible: AddBagOrStt[] = [...payloadSttNoOnly, ...payloadBagNoOnly]
    try {
      MainAppController.showLoading();
      const data = await CargoController.checkEligible(new RequestCheckEligibleReadyToCargo({bagOrStt: bagOrSttForCheckEligible}))
      if (data.isEligible) return true
      else {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "badge-warning-lg",
            title: this.$t("cargoV2.components.common.sttBagCannotUpdateTitle"),
            message: this.$t("cargoV2.components.common.sttBagCannotUpdateMessage"),
            textSuccess: "Cek Data",
            onSubmit: async () => {
              await this.$nextTick();
              const sttsPayload = payloadSttNoOnly.map((stt: any) => stt.stt_no).filter((stt: string) => stt);
              const bagsPayload = payloadBagNoOnly.map((bag: any) => bag.bag_no).filter((bag: string) => bag);
              const payload = [...sttsPayload, ...bagsPayload];

              const stts = data.bagOrStt.filter(stt => stt.sttNo).map(stt => stt.sttNo);
              const bags = data.bagOrStt.filter(bag => bag.bagNo).map(bag => bag.bagNo);
              const resp = [...stts, ...bags];

              const result = payload.filter((p) => !resp.includes(p));
              ReadyToCargoController.readyToCargoDetail.detail
              if (result.length) {
                CargoController.setSTTResultFinal([]);
                CargoController.setSourceFromLocalStorage([]);
                CargoController.setShowSelectAirportToLocalStorage(false);
                CargoController.cargoInputForm.id = 0;
                
                this.onEditReadyToCargo(ReadyToCargoController.readyToCargoDetail.id, ReadyToCargoController.readyToCargoDetail)
              } else {
                this.fetchReadyToCargoList();
                this.onReset();
              }
              MainAppController.closeMessageModal();
            }
          })
        );
        return false
      }
    }
    catch(e) {
      MainAppController.closeMessageModal();
      MainAppController.showErrorMessage(
        parsingErrorResponse(e, "Gagal terhubung ke server")
      )
      return false
    }
    finally {
      MainAppController.closeLoading();
    }
  }

  async showModalConfirmationBookCargo() {
    try {
      await ReadyToCargoController.getDetailReadyToCargo(ReadyToCargoController.readyToCargoDetail.id);
      console.log(ReadyToCargoController.readyToCargoDetail)
      if (!ReadyToCargoController.readyToCargoDetail.detail.length) {
        ReadyToCargoController.readyToCargoDetail.detail = [
          new CargoDetailStt({
            sttNumber: "-"
          })
        ]
        storeDatatoSessionStorage("cargo", ReadyToCargoController.readyToCargoDetail.detail = [
          new CargoDetailStt({
            sttNumber: "-"
          })
        ]);
        await this.$nextTick();
      }
      await this.$nextTick();
      const isEligible = await this.checkEligible();
      this.showModalForm = false;
      if (!isEligible) return;
    } catch (error) {
      this.fetchReadyToCargoList();
      return;
    }

    const isNeedRefresh = this.checkNeedRefreshData(this.dataReadyToCargo);
    const popupIllustration = this.formBooking.cargoType === "plane" ? "badge-confirmation-general" : "are-you-sure";
    const customWidth = this.formBooking.cargoType === "plane" ? "417px" : ""
    const buttonWidth = this.formBooking.cargoType === "plane" ? "w-full" : ""
    const buttonWrapper = this.formBooking.cargoType === "plane" ? "w-full px-6" : ""
    if (!isNeedRefresh) return;

    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: popupIllustration,
        title: "Konfirmasi Pembuatan",
        message: "Pastikan kembali, seluruh detail STT sudah benar dan sesuai.",
        textSuccess: "Process",
        textCancel: "Kembali",
        customWidth: customWidth,
        customButton: buttonWidth,
        customParentButton: buttonWidth,
        customWrapperButton: buttonWrapper,
        onSubmit: async () => {
          MainAppController.closeMessageModal();
          await this.onProcessReadyToCargo(this.dataReadyToCargo);
        },
        onClose: () => {
          MainAppController.closeMessageModal();
          this.showModalForm = true;
        }
      })
    );
  }

  async onProcessReadyToCargo(data: ReadyToCargo, bookingAutoType?: string, checkEligible = true) {
    if (checkEligible) {
      const isEligible = await this.checkEligible();
      if (!isEligible) return;
    }

    let isAuth = false;
    CargoController.setShowSelectAirportToLocalStorage(true);
    if (
      !getTokenNGen() &&
      !data.haveConfigCargoFlight &&
      data.cargoType === "plane"
    ) {
      isAuth = await NGenController.onLoginNGen();
    } else {
      isAuth = true;
    }
    if (isAuth) {
      if (this.cargoInputForm.id == 0) {
        try {
          await ReadyToCargoController.getDetailReadyToCargo(
            data.id,
            "rtc-process"
          );
          await this.$nextTick();
          const rtcList = CargoController.readyToCargoList;
          const newRtcData = this.readyToCargoDetail;
          rtcList.data = rtcList.data.map((rtc) => {
            if (rtc.id === data.id) return new ReadyToCargo({
              ...rtc,
              totalWeight: newRtcData.totalWeight,
              totalBagging: newRtcData.totalBagging,
              totalPieces: newRtcData.totalPieces,
              totalSttChargeableWeight: newRtcData.totalSttChargeableWeight,
              totalSttGrossWeight: newRtcData.totalSttGrossWeight,
              totalSttVolumeWeight: newRtcData.totalSttVolumeWeight
            });
            return rtc;
          })
          CargoController.setReadyToCargoList(rtcList);
          await this.$nextTick();
          if (!this.readyToCargoDetail.detail.length) {
            this.readyToCargoDetail.detail = [
              new CargoDetailStt({
                sttNumber: "-"
              })
            ]
          }
        } catch (error) {
          this.fetchReadyToCargoList();
          this.showSelectAirport = false;
          return;
        }
      }
      this.formBooking.actualDimension = new DimensionData();
      CargoController.mappingReadyToCargo();
      this.setFlowBooking("rtc-process");
      ReadyToCargoController.setEventName("booking_cargo_rtc_result");

      if (this.formBooking.cargoTypeStatus === "auto") {
        this.formBooking.airportOrigin.airportCode =
          ReadyToCargoController.readyToCargoDetail.originCode;
        this.formBooking.airportDestination.airportCode =
          ReadyToCargoController.readyToCargoDetail.destinationCode;
      }
      if (data.isMoreThanCutOffTime && bookingAutoType === "genesis") {
        await this.initPlaneAuto(ReadyToCargoController.readyToCargoDetail);
        CargoController.setAirportsPopupModel(
          JSON.parse(JSON.stringify(CargoController.form.airports))
        );
        if (this.readyToCargoDetail.detail.filter((v) => v.sttNumber !== "-").length) this.showSelectAirport = true;
        this.formBooking.cargoType = "plane";
        this.formBooking.cargoTypeStatus = "auto";
        this.formBooking.isRtc = true;
        this.formBooking.actualTotalCargoGrossWeight = ReadyToCargoController.readyToCargoDetail.totalWeight.toString();
        CargoController.setOnChangeTotalCargoVolumeWeight(
          Math.round(this.totalNewCalculationVolumeWeightsMaxFlag)
        );
        this.formBooking.transit = "0";
        this.onMappingCommodityGroup();
        await this.calculateVolume();
      } else if (this.readyToCargoDetail.detail?.length) {
        this.onCreateBooking();
      } else {
        // MainAppController.showMessageModal(
        //   new ModalMessageEntities({
        //     title: "Booking kargo gagal",
        //     message: "Data kargo ini sudah diproses, silakan cek kembali",
        //     textSuccess: "Oke, mengerti",
        //     image: "circle-error",
        //     onSubmit: () => {
        //       MainAppController.closeMessageModal();
        //       this.$emit("leave-page", "/cargo/create");
        //     }
        //   })
        // );
        //
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            image: "badge-warning-lg",
            title: this.$t("cargoV2.components.common.sttBagCannotUpdateTitle"),
            message: this.$t("cargoV2.components.common.sttBagCannotUpdateMessage"),
            textSuccess: "Cek Data",
            onSubmit: async () => {
              this.fetchReadyToCargoList();
              this.onReset();
              MainAppController.closeMessageModal();
            }
          })
        );
      }
    }
  }

  get commodityOptions(): OptionsClass[] {
    return CargoController.commodityOptions;
  }

  get commodityItem() {
    return CargoController.commodityItem;
  }

  onSelectCommodity(val: any) {
    if (val.value === this.commodityItem.value) {
      CargoController.setCommodityItem({
        value: "",
        name: ""
      });
      this.formBooking.cargoCommodityName = "";
      this.formBooking.cargoCommodityCode = "";
      this.formBooking.shcCode = "";
      this.formBooking.shcName = "";
      return;
    }
    CargoController.setCommodityItem(val);
    this.formBooking.cargoCommodityName = val.name;
    this.formBooking.cargoCommodityCode = val.value;
    this.formBooking.shcName = val.shcName;
    this.formBooking.shcCode = val.shcCode;
    const comodity = new OptionsClass({
      name: val.name,
      value: val.value,
      shcCode: val.shcCode,
      shcName: val.shcName
    });
    this.setCargoComodity(comodity);
  }

  setCargoComodity(value: OptionsClass) {
    CargoController.setCargoComodity(value);
  }

  get disableCommodityGroup(): boolean {
    return CargoController.disableCommodityGroup;
  }

  get readyToCargoDetail() {
    return ReadyToCargoController.readyToCargoDetail;
  }

  async checkForEditReadyToCargo(id: number, data: ReadyToCargo) {
    try {
      await ReadyToCargoController.getDetailReadyToCargo(id, "rtc-edit");
      CargoController.mappingReadyToCargo();
      await this.$nextTick();
      const isEligible = await this.checkEligible();
      if (isEligible) await this.onEditReadyToCargo(id, data)
    } catch (error) {
      this.fetchReadyToCargoList();
    }
  }

  async onEditReadyToCargo(id: number, data: ReadyToCargo) {
    const isNeedRefresh = this.checkNeedRefreshData(data);
    if (!isNeedRefresh) return;

    let isAuth = false;
    if (
      !getTokenNGen() &&
      !data.haveConfigCargoFlight &&
      data.cargoType === "plane"
    ) {
      isAuth = await NGenController.onLoginNGen();
    } else {
      isAuth = true;
    }
    if (isAuth) {
      if (this.cargoInputForm.id == 0) {
        await ReadyToCargoController.getDetailReadyToCargo(id, "rtc-edit");
      }
      this.formBooking.actualDimension = new DimensionData();
      await this.$nextTick();
      CargoController.mappingReadyToCargo();
      this.setFlowBooking("rtc-edit");
      ReadyToCargoController.setEventName("edit_cargo_rtc_booking_result");
      if (this.formBooking.cargoTypeStatus === "auto") {
        this.formBooking.airportOrigin.airportCode =
          ReadyToCargoController.readyToCargoDetail.originCode;
        this.formBooking.airportDestination.airportCode =
          ReadyToCargoController.readyToCargoDetail.destinationCode;
      }

      CargoController.setCargoOptions({ data: [] });
      CargoController.setShowCargoOptions(false);
      CargoController.setProgressValue(0);
      CargoController.setIsEditReadyToCargo(true);
      CargoController.setIsFirstLandingEditRTC(true);
    }
  }

  setFlowBooking(value: string) {
    ReadyToCargoController.setFlowBooking(value);
  }

  get activeTabs() {
    return CargoController.activeTabs;
  }
  get tabs() {
    return CargoController.tabsList;
  }

  getTabs() {
    if (this.originCity.code) {
      CargoController.getCargoOptions({
        origin: {
          code: this.originCity.code || "",
          name: this.originCity.name
        },
        destination: {
          code: "",
          name: ""
        },
        isPlaneManual: false
      });
    }
  }
  changeTabs(value: string) {
    CargoController.setActiveTabs(value);
    ClientController.getRTCListClientParent(value);
    CargoController.setDestinationCityRTC("");
    CargoController.setClientValue("");
    this.readyToCargoList.pagination.page = 1;
    this.fetchReadyToCargoList();
    this.onReset();
  }

  isTabActive(name: string) {
    return name === this.activeTabs;
  }

  cargoType(type: string) {
    return cargoTypeData(type);
  }

  get progress(): number {
    return CargoController.progressValue;
  }

  get flagsGamification() {
    return FlagsPermissionCargo.feature_is_gamification.isEnabled();
  }

  get partnerName() {
    return capitalize(this.dataProfile.account_type_detail.company_name);
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get typeUser() {
    return this.dataProfile.normalizedTypeUser;
  }

  get detailDistrict() {
    return LocationController.districtDetail;
  }

  get isPlaneAuto() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus === "auto"
    );
  }

  get totalStt() {
    return this.sttResult.reduce((prev, curr: any) => {
      if (curr?.sttDetails) return prev + curr.sttDetails.length
      return prev + 1
    }, 0)
  }

  get totalPieces() {
    return CargoController.totalSttPieces;
  }

  onCloseSuccess() {
    this.setOpenSuccess(false);
    this.$emit("leave-page", "/cargo");
  }

  onCloseProcess() {
    this.$emit("leave-page", "/cargo/booking-in-progress");
  }

  convertProduct(name: string) {
    return name;
  }

  get bagResult(): { baggingNumber: string; stt: CargoDetailStt[] }[] {
    return CargoController.bagResult;
  }

  get sttResult(): CargoDetailStt[] {
    return CargoController.sttResultFinal;
  }

  get iconTogglePanel() {
    const refs: any = this.$refs;
    return refs?.op?.visible ? "chevron-up-white" : "chevron-down-white";
  }

  withPrint = false;
  withPrintLabel = false;
  countSuccess = 0;
  countFailed = 0;

  get rcId(): number {
    return Number(this.$route.query.rcId);
  }

  get destinationCity(): OptionsClass {
    return CargoController.destinationCity;
  }

  get isRtc() {
    return (
      ReadyToCargoController.flowBooking === "rtc-process" ||
      ReadyToCargoController.flowBooking === "rtc-edit"
    );
  }

  showPopupTimeout(resp: any) {
    if (resp.bookingRequestId) {
      //success RTC Ngen
      this.showModalMessageBookingOnProcess(
        `Booking Kargo ${resp.bookingRequestId} <br/> Sedang Diproses`
      );
      this.bookingCargoGTM(this.eventName, "success");
    } else {
      //timeout RTC Ngen
      if (resp.cargoNo) {
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: "Booking Kargo Gagal Diproses nGen",
            message:
              "Lihat alasannya di halaman gagal booking. Cek & booking ulang",
            textSuccess: "OK",
            image: "image-modal-failed",
            onSubmit: () => {
              MainAppController.closeMessageModal();
              this.$emit("leave-page", "/cargo/booking-canceled");
            }
          })
        );
      } else {
        if (resp.totalSttFailed && !resp.totalSttSuccess) {
          this.countFailed = resp.totalSttFailed;
          this.setFailed(true);
          CargoController.setSttFailed(resp.listSttFailed);

          // GTM
          this.bookingCargoGTM(this.eventName, "failed");
          const gtmBookingCargoFailed = gtmCargoData({
            type: this.formBooking.cargoType,
            isAuto: this.isPlaneAuto
          }).bookingCargoFailed;

          dataLayer(
            gtmBookingCargoFailed.eventName,
            gtmBookingCargoFailed.property,
            ["timestamp"]
          );
        } else if (resp.totalSttFailed && resp.totalSttSuccess) {
          this.countFailed = resp.totalSttFailed;
          this.countSuccess = resp.totalSttSuccess;
          this.isPartial = true;
          CargoController.setSttFailed(resp.listSttFailed);
          this.onPrint();
        }
      }
    }
    MainAppController.closeLoading();
  }

  get minimumWeight() {
    return FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
  }
  get volumeWeightFlag() {
    return this.minimumWeight !== 0;
  }
  async calculateVolume() {
    await CargoController.calculateVolume(
      new CalculateVolumeApiRequest({
        calculateType: CALCULATE_TYPE.INIT,
        calculateRequest: new CalculateVolumeRequest({
          cargoType: this.formBooking.cargoType,
          totalPieces: this.totalPieces, // total koli kargo
          length: 90, // hardcode
          width: 60, // hardcode
          currentGrossWeight: this.validationPayloadTimbangUlang.estTotalCargoGrossweigth, // dari berat kotor timbang ulang
          volumeWeightReweigh: this.validationPayloadTimbangUlang.actualTotalCargoVolumeweight, // dari berat timbang ulang
          chargeableWeightReweigh: this.chargeableWeight,
          divider: getConfigDimensionDivider(this.formBooking.cargoType),
          isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus),
          minVolumePerPiece: getConfigMinimumVolumePerPiece(this.formBooking.cargoType, this.formBooking.cargoTypeStatus)
        })
      }))
  }
  async onCreateBooking() {
    try {
      MainAppController.showLoading();
      await this.calculateVolume();
      this.onSave();
    } catch (error) {
      MainAppController.closeLoading();
      this.onErrorCreateCargo(error, this.onCreateBooking);
    }
  }
  async onSave(): Promise<void> {
    const payloadBagNoOnly = JSON.parse(
      getDataSessionStorage("cargo-bag") || "[]"
    )
      .map((item: any) =>
        item.isFromRebooking ? null : new AddBagOrStt(item.baggingNumber)
      )
      .filter((items: any) => items != null);

    const payloadSttNoOnly = JSON.parse(getDataSessionStorage("cargo") || "[]")
      .filter(
        (item: any) =>
          !JSON.parse(
            getDataSessionStorage("cargo-bag") || "[]"
          ).find((bag: any) => JSON.stringify(bag).includes(item.sttNumber)) ||
          JSON.parse(getDataSessionStorage("cargo-bag") || "[]").find(
            (itemBag: any) => item.isFromRebooking == itemBag.isFromRebooking // add validation to check on cargo-bag that come from rebooking
          )
      )
      .map((item: any) => {
        if (item.sttDetails) {
          return item.sttDetails.map(
            (item: any) => new AddBagOrStt(undefined, item.sttNumber)
          );
        } else {
          return new AddBagOrStt(undefined, item.sttNumber);
        }
      })
      .flat();
    if (
      this.formBooking.cargoType === "plane" &&
      this.calculateFlightDate.length &&
      this.flowBooking === "rtc-process"
    ) {
      this.formBooking.airportOrigin.value = this.calculateFlightDate[0]?.flight_origin;
      this.formBooking.airportDestination.value = this.calculateFlightDate[
        this.calculateFlightDate.length - 1
      ]?.flight_destination;
    }
    CargoController.setTimestampBooking(new Date().getTime());

    const resp = await CargoController.onCreateCargo({
      originAirportCode:
        this.formBooking.airportOrigin.value ||
        LocationController.districtDetail.cityCode,
      destinationAirportCode:
        this.formBooking.airportDestination.value ||
        this.formBooking.destinationCityCode,
      estTotalCargoGrossweigth: this.validationPayloadTimbangUlang.estTotalCargoGrossweigth, // dari berat kotor timbang ulang
      estTotalCargoVolumeweight: this.validationPayloadTimbangUlang.estTotalCargoVolumeweight, // dari berat volume timbang ulang
      partnerName: this.partnerName,
      partnerType: this.typeUser,
      cargoNo: this.cargoPlaneAutoData.cargoNumber,
      cargoVehicleNo: this.cargoPlaneAutoData.vehicleNumber,
      actualTotalCargoGrossweigth: this.validationPayloadTimbangUlang.actualTotalCargoGrossweigth, // dari response atau hasil perhitungan timbang ulang
      actualTotalCargoVolumeweight: this.validationPayloadTimbangUlang.actualTotalCargoVolumeweight, // dari response calulate.volume_weight
      route: this.cargoPlaneAutoData.route, // from nGen
      totalStt: this.totalStt,
      totalPiece: this.totalPieces,
      cargoCommodity: this.formBooking.cargoCommodityCode,
      productCargo: this.formBooking.cargoProduct,
      cargoType: this.formBooking.cargoType,
      originCityCode: this.detailDistrict.cityCode,
      destinationCityCode: this.formBooking.destinationCityCode,
      departureDate: dateTimePayload(this.cargoPlaneAutoData.estDepartureDate),
      arrivalDate: dateTimePayload(this.cargoPlaneAutoData.estArrivalDate),
      bagOrStt: [...payloadSttNoOnly, ...payloadBagNoOnly],
      isCargoPlaneManual:
        this.formBooking.cargoType === "plane" &&
        this.formBooking.cargoTypeStatus === "manual",
      cargoOverCutoffLimit: CargoController.isOverCutOffTime || this.readyToCargoDetail.isMoreThanCutOffTime,
      cargoRtcTurnAuto: false,
      cargoActualPiece: +this.formBooking.actualTotalSTTPieces,
      flightPlanForECargo: this.cargoPlaneAutoData.flightData,
      /* "dimensions": [
          {
              "length": 90, // default
              "width": 60, // default
              "height": 2, // dari response calulate.height
              "pieces": 8 // perhitungan jumlah koli kargo
          }
      ], */
      dimensions: this.validationPayloadTimbangUlang.dimensions,
      estDimension: this.formBooking.estDimension,
      /* "actual_dimension": {
        "cargo_actual_length_dimension": 90, // default
        "cargo_actual_width_dimension": 60, // default
        "cargo_actual_height_dimension": 2 // dari response calulate.height
      }, */
      actualDimension: this.validationPayloadTimbangUlang.actualDimension,
      isFromRtc: this.isRtc,
      rtcId: this.isRtc ? ReadyToCargoController.readyToCargoDetail.id : 0,
      nog: this.formBooking.nog,
      rebookingId: this.rcId,
      ngenCreatedAt: dateTimePayload(this.formBooking.ngenCreatedAt),
      shc: this.formBooking.shcCode,
      photoProof: this.formBooking.photoProof.filter((photo: any) => typeof photo === "string").filter(Boolean),
      cargoTotalChargeableWeight: CargoController.totalSttChargeableWeight, // chargeable weight stt
      cargoTotalCustomChargeableWeight: this.actualChargeableWeight, // response calulate.chargeable_weight
      cargoTotalEstimateChargeableWeight: this.chargeableWeight, // timbang ulang
      isNewCalculation: this.featureHideDimensionKoli,
      calculateType: CALCULATE_TYPE.INIT // jika dari booking sekarang akan selalu INIT
    })
      .catch((err: any) => {
        this.onErrorCreateCargo(err, this.onSave);
      })
      .finally(() => {
        MainAppController.closeMessageModal();
      });
    this.onCreateResponse(resp);
  }
  onErrorCreateCargo(err: any, onRetry: () => void) {
    MainAppController.showErrorMessage(
      parsingErrorResponse(
        err,
        AccountController.accountData.accountIsForeign
          ? "Failed to Cargo Booking !"
          : "Pembuatan Gagal !",
        () => {
          MainAppController.closeErrorMessage();
          onRetry();
        },
        () => {
          handleFailedBookingNavigation({
            router: this.$router,
            rcId: this.$route.query.rcId,
            cargoType: this.formBooking.cargoType,
            cargoTypeStatus: this.formBooking.cargoTypeStatus,
            flowBooking: this.flowBooking
          });
        }
      )
    );
  }

  recalculateVolumeForDirectMessage() {
    if (flags.feature_hide_dimension_koli.isEnabled()) {
      const dimension =
        (this.formBooking.actualDimension.width *
          this.formBooking.actualDimension.height *
          this.formBooking.actualDimension.length) /
        getConfigDimensionDivider("plane");
      const result = dimension * this.totalPieces;
      return result < 1 ? 1 : Math.round(result);
    }

    return this.formDetailPieces.dimensionPieces.reduce(
      (total, item) =>
        commaDecimalToDecimal(
          convertDecimalAfterComma(
            total +
              (item.volumeWeight
                ? commaDecimalToDecimal(item.volumeWeight)
                : 0),
            2
          )
        ),
      0
    )
  }

  get cargoPlaneAutoData(): CargoPlaneAutoData {
    if (
      this.formBooking.cargoType === "plane" &&
      this.calculateFlightDate.length &&
      this.flowBooking === "rtc-process"
    ) {
      return new CargoPlaneAutoData({
        estDepartureDate: this.calculateFlightDate[0].flight_dep_datetime,
        estArrivalDate: this.calculateFlightDate[
          this.calculateFlightDate.length - 1
        ].flight_arr_datetime,
        flightData: this.calculateFlightDate
      });
    }
    return new CargoPlaneAutoData({
      estDepartureDate: this.formBooking.estDepartureDate,
      estArrivalDate: this.formBooking.estArrivalDate,
      cargoNumber: this.formBooking.cargoNumber,
      vehicleNumber: this.formBooking.vehicleNumber
    });
  }

  // failed for create
  isPartial = false;
  get timestampBooking() {
    return CargoController.timestampBooking;
  }
  get isFailed(): boolean {
    return CargoController.isFailed;
  }

  get chargeableWeight() {
    return Math.max(
      1,
      this.parseNumber(String(CargoController.totalNewCalculationGrossWeights)),
      this.parseNumber(String(this.totalNewCalculationVolumeWeights))
    );
  }

  get calculateFlightDate() {
    return ReadyToCargoController.calculateFlightDate.map((key: any) => {
      return {
        ...key,
        flight_threshold_time: key.flight_threshold_time
      }
    });
  }

  setFailed(value: boolean) {
    CargoController.setFailed(value);
  }

  showModalMessageBookingOnProcess(title: string) {
    const popupIllustration = this.formBooking.cargoType === "plane" ? "on-process-booking-cargo" : "illustration_waiting_process";
    const customWidth = this.formBooking.cargoType === "plane" ? "417px" : ""
    const buttonWidth = this.formBooking.cargoType === "plane" ? "w-full" : ""
    const buttonWrapper = this.formBooking.cargoType === "plane" ? "w-full px-6" : ""
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title,
        message: "Anda akan mendapat notifikasi jika booking kargo berhasil",
        textSuccess: "OK",
        image: popupIllustration,
        customWidth: customWidth,
        customButton: buttonWidth,
        customParentButton: buttonWidth,
        customWrapperButton: buttonWrapper,
        onSubmit: () => {
          MainAppController.closeMessageModal();
          this.onCloseSuccess();
        }
      })
    );
  }

  get isBookingV4() {
    return flags.feature_is_booking_cargo_v4.isEnabled();
  }

  onCreateResponse(resp: any) {
    if (resp) {
      CargoController.resetScanFailedList();

      if (
        this.formBooking.cargoType === "plane" &&
        this.isRtc &&
        this.isBookingV4
      ) {
        this.showPopupTimeout(resp);
        return;
      } else if (resp.cargoNo.startsWith("FLIGHT") || resp.isCargoUsingAwb) {
        //error Ngen Non RTC
        this.showModalMessageBookingOnProcess("Booking Kargo Sedang Diproses");
        this.bookingCargoGTM(this.eventName, "success");
      } else if (resp.totalSttFailed && !resp.totalSttSuccess) {
        this.countFailed = resp.totalSttFailed;
        this.setFailed(true);
        CargoController.setSttFailed(resp.listSttFailed);

        // GTM
        this.bookingCargoGTM(this.eventName, "failed");
        const gtmBookingCargoFailed = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: this.isPlaneAuto
        }).bookingCargoFailed;

        dataLayer(
          gtmBookingCargoFailed.eventName,
          gtmBookingCargoFailed.property,
          ["timestamp"]
        );
      } else if (resp.totalSttFailed && resp.totalSttSuccess) {
        this.countFailed = resp.totalSttFailed;
        this.countSuccess = resp.totalSttSuccess;
        this.isPartial = true;
        CargoController.setSttFailed(resp.listSttFailed);
        this.onPrint();
      } else {
        // GTM
        this.bookingCargoGTM(this.eventName, "success");
        const gtmBookingCargoSuccess = gtmCargoData({
          type: this.formBooking.cargoType,
          isAuto: this.isPlaneAuto,
          gtmData: {
            cargoNumber: CargoController.cargoIdToGeneratePdf,
            flightNumber: this.formBooking.vehicleNumber
          }
        }).bookingCargoSuccess;

        dataLayer(
          gtmBookingCargoSuccess.eventName,
          gtmBookingCargoSuccess.property,
          ["timestamp"]
        );

        CargoController.setOpenSuccess(true);
        this.onPrint();
      }
    }
  }

  bookingCargoGTM(eventName: any, result: string) {
    GTMBookingCargoEvent(eventName, {
      cargo_type: this.formBooking.cargoType,
      "3LC_origin": this.detailDistrict.cityCode,
      "3LC_destination": this.formBooking.destinationCityCode,
      booking_result: result,
      cargo_number: CargoController.cargoIdToGeneratePdf,
      timestamp_booking: this.timestampBooking,
      timestamp_get_result: new Date().getTime()
    });
  }

  get eventName() {
    return ReadyToCargoController.eventName;
  }

  onPrint() {
    const refs: any = this.$refs;
    if (this.withPrint) {
      refs.print.printManifestV2(CargoController.cargoIdToGeneratePdf);

      // GTM
      const gtmBookingCargoSuccessPDF = gtmCargoData({
        type: this.formBooking.cargoType,
        isAuto: this.isPlaneAuto,
        gtmData: {
          cargoNumber: CargoController.cargoIdToGeneratePdf,
          flightNumber: this.formBooking.vehicleNumber
        }
      }).bookingCargoSuccessPDF;

      dataLayer(
        gtmBookingCargoSuccessPDF.eventName,
        gtmBookingCargoSuccessPDF.property,
        ["timestamp"]
      );
    }
    if (this.withPrintLabel) {
      refs.print.printData(CargoController.cargoIdToGeneratePdf, "label");

      // GTM
      const gtmBookingCargoSuccessLabel = gtmCargoData({
        type: this.formBooking.cargoType,
        isAuto: this.isPlaneAuto,
        gtmData: {
          cargoNumber: CargoController.cargoIdToGeneratePdf,
          flightNumber: this.formBooking.vehicleNumber
        }
      }).bookingCargoSuccessLabel;

      dataLayer(
        gtmBookingCargoSuccessLabel.eventName,
        gtmBookingCargoSuccessLabel.property,
        ["timestamp"]
      );
    }
  }

  get openSuccess(): boolean {
    return CargoController.isOpenSuccess;
  }

  setOpenSuccess(value: boolean) {
    CargoController.setOpenSuccess(value);
  }

  get isShowPopup(): boolean {
    return this.openSuccess || this.isPartial || this.isFailed;
  }

  get popupModalData() {
    // if success
    if (this.openSuccess) {
      return {
        success: {
          action: this.onCloseSuccess,
          text: "OK"
        },
        title: "Pembuatan Berhasil !",
        message: `Pengiriman kargo dengan nomor<br /><b>“${CargoController.cargoIdToGeneratePdf}”</b> berhasil dibuat.`,
        image: "image-modal-success"
      };
    }

    // if success partially
    if (this.isPartial) {
      return {
        success: {
          action: () => this.onDownloadCsvFailedStt(this.sttFailedUpdate),
          text: "Download"
        },
        cancel: {
          action: this.onCloseSuccess,
          text: "OK"
        },

        title: "Pembuatan Berhasil !",
        message: `Beberapa No. STT berhasil dibuat jadwal pengiriman kargo<br />dengan nomor <b>“${CargoController.cargoIdToGeneratePdf}”</b>. Namun terdapat kegagalan<br />pada beberapa STT. Silahkan hapus STT bermasalah untuk<br />melanjutkan pengiriman kargo.`,
        image: "image-modal-warning"
      };
    }

    // default is failed
    return {
      success: {
        action: () => this.onDownloadCsvFailedStt(this.sttFailedUpdate),
        text: "Download"
      },
      cancel: {
        action: () => {
          this.setFailed(false);
          this.onReset();
        },
        text: "OK"
      },
      title: "Pembuatan Gagal !",
      message: "Pengiriman kargo gagal dibuat.",
      image: "image-modal-failed"
    };
  }

  get sttFailedUpdate() {
    return CargoController.sttFailed;
  }

  setPartial(value: boolean) {
    this.isPartial = value;
  }

  onDownloadCsvFailedStt(data: any) {
    this.downloadCsvFailedStt({
      fileName: "cargo_stt_failed.csv",
      listStt: data
    });
  }

  get formDetailPieces() {
    return CargoController.formDetailPieces;
  }

  get isHaveBeenSubmitDetailPieces() {
    return CargoController.isHaveBeenSubmitDetailPieces;
  }

  get featureHideDimensionKoli(): boolean {
    return flags.feature_hide_dimension_koli.isEnabled();
  }
  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }
  get totalNewCalculationVolumeWeightsMaxFlag() {
    return this.parseNumber(this.formBooking.actualTotalCargoVolumeWeight) || this.totalNewCalculationVolumeWeights;
  }

  get dimensionTimbangUlang() {
    const volumeWeight = Math.round(
      this.totalNewCalculationVolumeWeightsMaxFlag
    );

    const divider = getConfigDimensionDivider(this.formBooking.cargoType);

    const pieces = this.readyToCargoDetail.totalPieces;
    const length = 90;
    const width = 60;
    const height = Math.max(1,Math.floor(
      (volumeWeight * divider) / (length * width * pieces)
    ));

    return {
      length,
      width,
      height,
      pieces
    };
  }
  get mappingDetailPieces() {
    return this.formDetailPieces.dimensionPieces.map((item) => {
      return {
        pieces: !this.isHaveBeenSubmitDetailPieces
          ? +this.formBooking.actualTotalSTTPieces
          : +item.pieces,
        length: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.length
          : item.length,
        width: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.width
          : item.width,
        height: !this.isHaveBeenSubmitDetailPieces
          ? this.formBooking.actualDimension.height
          : item.height,
        "gross_weight": item.sttOrBag ? item.grossWeight : undefined,
        "volume_weight": item.sttOrBag ? item.volumeWeight : undefined,
        "stt_or_bag": item.sttOrBag
      };
    });
  }
  
  get actualTotalCargoVolumeweight() {
    const totalCargoVolumWeight = this.volumeWeightFlag
      ? Number(this.formBooking.actualTotalCargoVolumeWeight) <
        Number(this.minimumWeight)
        ? this.minimumWeight
        : this.formBooking.actualTotalCargoVolumeWeight
      : this.formBooking.actualTotalCargoVolumeWeight;

  return this.formBooking.cargoType === "plane"
      ? this.recalculateVolumeForDirectMessage()
      : commaDecimalToDecimal(totalCargoVolumWeight);
  }
  get isUsePayloadTimbangUlang() {
    return this.formBooking.cargoType !== "plane" || this.featureHideDimensionKoli
  }
  get validationPayloadTimbangUlang() {
    const actualTotalCargoGrossweigth = commaDecimalToDecimal(
      this.formBooking.actualTotalCargoGrossWeight
    );
    if (this.isUsePayloadTimbangUlang) {
      // if (this.flowBooking === "rtc-process") this.formBooking.actualDimension.height = this.dimensionTimbangUlang.height
      return {
        actualDimension: this.formBooking.actualDimension,
        dimensions: this.mappingDetailPieces,
        actualTotalCargoGrossweigth, // dari response atau hasil perhitungan timbang ulang
        actualTotalCargoVolumeweight: Math.round(
          this.totalNewCalculationVolumeWeightsMaxFlag
        ), // dari response calulate.volume_weight
        estTotalCargoGrossweigth: CargoController.totalNewCalculationGrossWeights, // dari berat kotor timbang ulang
        estTotalCargoVolumeweight: this.totalNewCalculationVolumeWeights // dari berat volume timbang ulang
      };
    }

    return {
      actualDimension: this.formBooking.actualDimension,
      dimensions: this.mappingDetailPieces,
      actualTotalCargoGrossweigth, // dari response atau hasil perhitungan timbang ulang
      actualTotalCargoVolumeweight: this.actualTotalCargoVolumeweight, // dari response calulate.volume_weight
      estTotalCargoGrossweigth: commaDecimalToDecimal(
        this.formBooking.estTotalCargoGrossWeight
      ), // dari berat kotor timbang ulang
      estTotalCargoVolumeweight: commaDecimalToDecimal(
        this.formBooking.estTotalCargoVolumeWeight
      ) // dari berat volume timbang ulang
    };
  }

  get actualChargeableWeight() {
    if (this.isUsePayloadTimbangUlang) {
      return CargoController.calculateVolumeData.chargeableWeight;
    }

    return Math.max(
      1,
      this.parseNumber(this.formBooking.actualTotalCargoGrossWeight),
      this.parseNumber(this.formBooking.actualTotalCargoVolumeWeight)
    );
  }
  get calculateVolumeData() {
    return CargoController.calculateVolumeData;
  }
  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  onChangeNog(value: string) {
    CargoController.setOnChangeNog(value);
  }

  onChangeVehicleNumber(value: string) {
    CargoController.setOnChangeVehicleNumber(value);
  }

  onChangeCargoNumber(value: string) {
    CargoController.setUpdateFromBookingCargoNumber(value);
  }

  onChangePagination(newPage: number) {
    this.readyToCargoList.pagination.page = newPage;
    this.fetchReadyToCargoList();
  }

  get isCargoTrain() {
    return this.formBooking.cargoType === "train";
  }

  get isCargoShip() {
    return this.formBooking.cargoType === "ship";
  }

  get isCargoTruck() {
    return this.formBooking.cargoType === "truck";
  }

  get isCargoPlaneManual() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus !== "auto"
    );
  }

  get isCargoPlaneAuto() {
    return (
      this.formBooking.cargoType === "plane" &&
      this.formBooking.cargoTypeStatus === "auto"
    );
  }

  get isFormBookingValid() {
    const cargoNumber =
      this.formBooking.cargoTypeStatus !== "auto" &&
      this.formBooking.cargoType !== "truck"
        ? this.formBooking.cargoNumber
        : true;
    const vehicleNumber =
      this.formBooking.cargoTypeStatus !== "auto"
        ? this.formBooking.vehicleNumber
        : true;

    const validProduct =
      Boolean(
        this.readyToCargoDetail.rtcCargoProductType ||
          this.formBooking.cargoProduct
      );

    return !cargoNumber || !vehicleNumber || !validProduct;
  }

  get shcValue() {
    return this.formBooking.shcCode && this.formBooking.shcName
      ? `${this.formBooking.shcCode} - ${this.formBooking.shcName}`
      : "-";
  }

  get showModalTest() {
    return CargoController.isShowModalGamification;
  }

  get estimationNextDeparture() {
    const {
      isMoreThanCutOffTime,
      nextCargoFlightTime,
      flightsData
    } = this.dataReadyToCargo;

    return formatDate(
      isMoreThanCutOffTime
        ? nextCargoFlightTime
        : flightsData?.[0].DepartureDateTime,
      "DD MMMM YYYY, HH:mm",
      false
    );
  }

  getCargoProductList() {
    CargoController.getCargoProductList({
      status: "active"
    });
  }
  get listProductCargo() {
    const defaultChoices: any = [
      {
        name: "Pilih tipe produk kargo",
        value: "",
        status: ""
      }
    ];
    const cargos = CargoController.cargoProductList.data.map((e: any) => ({
      name: e.cargoProductTypeCode,
      value: e.cargoProductTypeCode,
      status: e.cargoProductTypeStatus
    }));

    return defaultChoices.concat(cargos);
  }
  isOpenSelectCargoProduct = false;
  onOpenSelectCargoProduct() {
    this.isOpenSelectCargoProduct = true;
  }
  onCloseSelectCargoProduct() {
    this.isOpenSelectCargoProduct = false;
  }
  onSelectCargoProduct(_: string, value: string) {
    this.onCloseSelectCargoProduct();
    CargoController.setOnSelectCargoProduct(value);
    this.readyToCargoDetail.rtcCargoProductType = value;
  }
}
